<section class="container__main">
    <app-post *ngFor="let post of posts" imgDetail={{post.photo}} dateDetail={{post.date}} titleDetail={{post.title}} contentDetail={{post.description}}></app-post>
</section>